export default {
    auditLogs: 'Audit Logs',
    logsList: 'Logs List',
    action: 'Action',
    startDateTime: 'Start date/time',
    endDateTime: 'End date/time',
    resource: 'Resource',
    description: 'Description',
};
